import { LBTButton, LBTLabel, LBTSpacer, Section } from '@laborability/components';
import { Box } from '@mui/material';

export default function Weltis() {

  return (
    <Section>
      <LBTSpacer spacing={4} />
      <Box>
        <LBTLabel variant="delaDisplay" maxWidth="980px" component="h1">
          Weltis: Pianificazione finanziaria indipendente
        </LBTLabel>
        <LBTSpacer spacing={4} />
        <LBTLabel variant="spGroteskSubtitle" maxWidth="980px">
          Gestire TFR, fondi pensione, investimenti e obiettivi di vita non dovrebbe essere un rebus. Weltis ti mette a fianco un esperto finanziario certificato e indipendente con nessun conflitto di interesse e nessun linguaggio da economista.
        </LBTLabel>
        <LBTSpacer spacing={2} />
        <LBTLabel variant="bodyText" maxWidth="980px">
          Parti da una sessione gratuita, 30 minuti in cui capisci dove sei e cosa ha senso fare per la tua situazione.
        </LBTLabel>
        <LBTSpacer spacing={2} />
        <LBTLabel variant="bodyText" maxWidth="980px">
          <b>Cosa puoi fare con Weltis:</b>
          <div style={{ textAlign: 'center' }}>
            <ul style={{ display: 'inline-block', textAlign: 'left', paddingLeft: '20px' }}>
              <li>Capire cosa fare con il tuo TFR e come ottimizzare la pensione</li>
              <li>Analizzare la tua situazione finanziaria e i tuoi investimenti</li>
              <li>Pianificare obiettivi concreti: casa, famiglia, serenità futura</li>
              <li>Avere un esperto al fianco nel tempo, non solo una volta</li>
            </ul>
          </div>
        </LBTLabel>
        <LBTSpacer spacing={2} />
        <LBTLabel variant="bodyText" maxWidth="980px">
          Disponibile per gli utenti Dritto con uno sconto del 5% su tutti i servizi.
        </LBTLabel>
      </Box>

      <LBTSpacer spacing={4} />
      <LBTButton
        datatestid="external_button_weltis"
        variant="contained"
        color="primary-negative"
        size="medium"
        onClick={() => window.open(`https://client.weltis.app/onboarding?utm_source=dritto`, '_blank', 'noopener,noreferrer')}
      >
        Prenota una sessione qui
      </LBTButton>

      <LBTSpacer spacing={6} />

    </Section>
  );
}
